const dataLayer = window.dataLayer || [];

const lead = (traceId, form) => {
  dataLayer.push({
    event: 'Lead',
    ecommerce: {
      purchase: {
        actionField: {
          id: traceId,
          affiliation: 'web',
          revenue: '1',
          tax: '0',
          shipping: '0',
          coupon: '0',
        },
        products: [{
          name: 'Registration',
          id: form,
          price: '1',
          brand: 'co3.io',
          category: '0',
          variant: '0',
          quantity: 1,
          coupon: '0',
        }],
      },
    },
  });
};

const client = (traceId) => {
  dataLayer.push({
    event: 'klient',
    pagePath: window.location.pathname,
    pageTitle: window.document.title,
    id: traceId,
  });
};

const pageView = () => {
  dataLayer.push({
    event: 'pageview',
    pagePath: window.location.pathname,
    pageTitle: window.document.title,
  });
};

const GoogleAnalyticsService = {
  lead,
  client,
  pageView,
};

export default GoogleAnalyticsService;
